export default __webpack_public_path__ + "static/media/alimentacion_parenteral_adultos.dd68f0fe.pdf";